import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => {


	const [posts, setpost] = useState([]);
	useEffect(() => {
		fetch("https://webeetec.com/itsharks24/blog/api/getcategory.php")
			.then(r => r.json())
			.then((r) => {
				setpost(r);
				console.log(r)


			})


	}, [])
	return (

		<header id="header">
			<div className="siteHeader">
				<div className="wrapper clear">
					<a href="index.html" className="mobile-logo">
					</a>
					<ul className="mainMenu clear">

						<li>
							<Link to='/'>home</Link>
						</li>
						<li>
							<Link to='book'>Book store</Link>
						</li>



						<li>
							<a href="#">Category</a>
							<ul>

								<li><Link to='/single'>single </Link></li>
								{

									posts.map((cat) => {
										return (
											<li><Link to={/single/}>{cat.name}</Link></li>
											// <li><Link to='categore'>Category </Link></li>


										)

									})
								}


							</ul>


						</li>

					</ul>
					<div className="pull-right clear">
						<div className="headerSocialLinks clear">
							<a href="#"><i className="fa fa-instagram"></i></a>
							<a href="#"><i className="fa fa-facebook"></i></a>
							<a href="#"><i className="fa fa-twitter"></i></a>
							<a href="#"><i className="fa fa-heart"></i></a>
							<a href="#"><i className="fa fa-pinterest"></i></a>
							<a href="#"><i className="fa fa-google-plus"></i></a>
						</div>
						<div className="searchIcon"></div>
					</div>
					<span className="showMobileMenu">
						<span></span>
						<span></span>
						<span></span>
						<span></span>
					</span>
				</div>
			</div>
			<a href="#" className="logo">IT SHARKS 26</a>
		</header>

	)
}

export default Navbar